import gql from 'graphql-tag';

export const getFeatureConfig = gql`
  query FeatureConfig($id: ID!) {
    feature(id: $id) {
      __typename

      ... on Feature {
        config
      }
    }
  }
`;
